<template>
    <div class="header"
    :style="{
        background: `${colors.primary}`,
        color: colors.theme == 'dark' ? `#000` : `#fff`,
    }">
        <div class="menu-header">
            <img v-if="colors.clientLogoPath" :src="colors.clientLogoPath" alt="" class="logo">
            <!-- <img src="../../assets/decode-logo.png" alt="" class="logo"> -->
            <DecodeLogo v-else></DecodeLogo>
            <div class="risk"></div>
            <p class="mission-name"
            :style="{
                color: colors.theme == 'dark' ? `#000` : `#000`,
            }">            
                <span class="program-name bold">{{title.workspaceTitle}}</span>
            </p>
        </div>
        <!-- <div class="info-game" v-if="clock"> -->
        <div class="help">
            <a class="help-content" href="https://huddlebrasil.zendesk.com/hc/pt-br/articles/360051351931-D%C3%BAvidas-Frequentes-Decode-Game-" target="_blank"
            :style='{ color : "#000"}'>
            <span>{{$t("Sections.HeaderDefault.help")}}</span>
            </a>            
        </div>
        <div class="info-game" v-if="clock">
            <info-game :loader="loader" typeInfo="clock" bgColor="#ffffff" :dataInfo="clockTime"></info-game>
        </div>
    </div>
</template>
<script>
import InfoGame from '../Shared/InfoGame.vue'
import DecodeLogo from '../Shared/CustomIcons/Header/logoDecode.vue'
export default {
    components:{
        InfoGame,
        DecodeLogo
    },
    props : {
        clock : {
            type : Boolean,
            default : false
        },
        clockTime : {
            type : String
        },
        loader : {
            type : Boolean
        }
    },
    created(){
        this.title = this.$store.getters.getSimple(['workspaceTitle'])
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    data(){
        return{
            title : '',
            colors: {}
        }
    },
    computed: {
        program(){
            return this.$store.getters.mission
        }
    }
}
</script>
<style lang="scss" scoped>

    .header{
        width: 100%;
        height: 65px;
        display: flex;
        justify-content: space-between ;
        align-items: center;
        padding: 0 32px;
        // background-color: #6efbfe;


        .menu-header{

            height: 100%;
            width: 100%;
            display: flex;
            align-items: center;            

            .logo{
                height: 40%;
                // margin-left: 5%;
            }

            .risk{

                height: 40%;
                width: 2px;
                margin: 0 20px;
                background-color: rgba(0, 0, 0, 0.438);
            }

            .mission-name{
                display: flex;
                flex-direction: column;
                font-size: 10px;
                letter-spacing: 1px;
                max-width: 160px;
            }
        } 

        .info-game{
            display: flex;
            align-items: center;
        }
        .help-content{
            display: flex;
            align-items: center;
            text-decoration: none;

            &:hover{
                cursor: pointer;
            }

            span{
                border: 1px solid;
                border-radius: 40px;
                padding: 3px 19px;
                font-weight: 900;
                text-transform: uppercase;
            }
        }         
    }

    @media only screen and (max-width : 750px) {

        .header{
            padding: 0 15px;

            .menu-header{

                .logo{

                    height: 45%;
                }
            }
        }
    }

</style>
